(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*!
 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

(function(root, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  }
  else if (typeof exports === 'object') {
    // COMMONJS
    module.exports = factory();
  }
  else {
    // BROWSER
    root.Headroom = factory();
  }
}(this, function() {
  'use strict';

  /* exported features */
  
  var features = {
    bind : !!(function(){}.bind),
    classList : 'classList' in document.documentElement,
    rAF : !!(window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame)
  };
  window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  
  /**
   * Handles debouncing of events via requestAnimationFrame
   * @see http://www.html5rocks.com/en/tutorials/speed/animations/
   * @param {Function} callback The callback to handle whichever event
   */
  function Debouncer (callback) {
    this.callback = callback;
    this.ticking = false;
  }
  Debouncer.prototype = {
    constructor : Debouncer,
  
    /**
     * dispatches the event to the supplied callback
     * @private
     */
    update : function() {
      this.callback && this.callback();
      this.ticking = false;
    },
  
    /**
     * ensures events don't get stacked
     * @private
     */
    requestTick : function() {
      if(!this.ticking) {
        requestAnimationFrame(this.rafCallback || (this.rafCallback = this.update.bind(this)));
        this.ticking = true;
      }
    },
  
    /**
     * Attach this as the event listeners
     */
    handleEvent : function() {
      this.requestTick();
    }
  };
  /**
   * Check if object is part of the DOM
   * @constructor
   * @param {Object} obj element to check
   */
  function isDOMElement(obj) {
    return obj && typeof window !== 'undefined' && (obj === window || obj.nodeType);
  }
  
  /**
   * Helper function for extending objects
   */
  function extend (object /*, objectN ... */) {
    if(arguments.length <= 0) {
      throw new Error('Missing arguments in extend function');
    }
  
    var result = object || {},
        key,
        i;
  
    for (i = 1; i < arguments.length; i++) {
      var replacement = arguments[i] || {};
  
      for (key in replacement) {
        // Recurse into object except if the object is a DOM element
        if(typeof result[key] === 'object' && ! isDOMElement(result[key])) {
          result[key] = extend(result[key], replacement[key]);
        }
        else {
          result[key] = result[key] || replacement[key];
        }
      }
    }
  
    return result;
  }
  
  /**
   * Helper function for normalizing tolerance option to object format
   */
  function normalizeTolerance (t) {
    return t === Object(t) ? t : { down : t, up : t };
  }
  
  /**
   * UI enhancement for fixed headers.
   * Hides header when scrolling down
   * Shows header when scrolling up
   * @constructor
   * @param {DOMElement} elem the header element
   * @param {Object} options options for the widget
   */
  function Headroom (elem, options) {
    options = extend(options, Headroom.options);
  
    this.lastKnownScrollY = 0;
    this.elem             = elem;
    this.tolerance        = normalizeTolerance(options.tolerance);
    this.classes          = options.classes;
    this.offset           = options.offset;
    this.scroller         = options.scroller;
    this.initialised      = false;
    this.onPin            = options.onPin;
    this.onUnpin          = options.onUnpin;
    this.onTop            = options.onTop;
    this.onNotTop         = options.onNotTop;
    this.onBottom         = options.onBottom;
    this.onNotBottom      = options.onNotBottom;
  }
  Headroom.prototype = {
    constructor : Headroom,
  
    /**
     * Initialises the widget
     */
    init : function() {
      if(!Headroom.cutsTheMustard) {
        return;
      }
  
      this.debouncer = new Debouncer(this.update.bind(this));
      this.elem.classList.add(this.classes.initial);
  
      // defer event registration to handle browser
      // potentially restoring previous scroll position
      setTimeout(this.attachEvent.bind(this), 100);
  
      return this;
    },
  
    /**
     * Unattaches events and removes any classes that were added
     */
    destroy : function() {
      var classes = this.classes;
  
      this.initialised = false;
  
      for (var key in classes) {
        if(classes.hasOwnProperty(key)) {
          this.elem.classList.remove(classes[key]);
        }
      }
  
      this.scroller.removeEventListener('scroll', this.debouncer, false);
    },
  
    /**
     * Attaches the scroll event
     * @private
     */
    attachEvent : function() {
      if(!this.initialised){
        this.lastKnownScrollY = this.getScrollY();
        this.initialised = true;
        this.scroller.addEventListener('scroll', this.debouncer, false);
  
        this.debouncer.handleEvent();
      }
    },
  
    /**
     * Unpins the header if it's currently pinned
     */
    unpin : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(classList.contains(classes.pinned) || !classList.contains(classes.unpinned)) {
        classList.add(classes.unpinned);
        classList.remove(classes.pinned);
        this.onUnpin && this.onUnpin.call(this);
      }
    },
  
    /**
     * Pins the header if it's currently unpinned
     */
    pin : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(classList.contains(classes.unpinned)) {
        classList.remove(classes.unpinned);
        classList.add(classes.pinned);
        this.onPin && this.onPin.call(this);
      }
    },
  
    /**
     * Handles the top states
     */
    top : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.top)) {
        classList.add(classes.top);
        classList.remove(classes.notTop);
        this.onTop && this.onTop.call(this);
      }
    },
  
    /**
     * Handles the not top state
     */
    notTop : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.notTop)) {
        classList.add(classes.notTop);
        classList.remove(classes.top);
        this.onNotTop && this.onNotTop.call(this);
      }
    },
  
    bottom : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.bottom)) {
        classList.add(classes.bottom);
        classList.remove(classes.notBottom);
        this.onBottom && this.onBottom.call(this);
      }
    },
  
    /**
     * Handles the not top state
     */
    notBottom : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.notBottom)) {
        classList.add(classes.notBottom);
        classList.remove(classes.bottom);
        this.onNotBottom && this.onNotBottom.call(this);
      }
    },
  
    /**
     * Gets the Y scroll position
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY
     * @return {Number} pixels the page has scrolled along the Y-axis
     */
    getScrollY : function() {
      return (this.scroller.pageYOffset !== undefined)
        ? this.scroller.pageYOffset
        : (this.scroller.scrollTop !== undefined)
          ? this.scroller.scrollTop
          : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    },
  
    /**
     * Gets the height of the viewport
     * @see http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
     * @return {int} the height of the viewport in pixels
     */
    getViewportHeight : function () {
      return window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
    },
  
    /**
     * Gets the physical height of the DOM element
     * @param  {Object}  elm the element to calculate the physical height of which
     * @return {int}     the physical height of the element in pixels
     */
    getElementPhysicalHeight : function (elm) {
      return Math.max(
        elm.offsetHeight,
        elm.clientHeight
      );
    },
  
    /**
     * Gets the physical height of the scroller element
     * @return {int} the physical height of the scroller element in pixels
     */
    getScrollerPhysicalHeight : function () {
      return (this.scroller === window || this.scroller === document.body)
        ? this.getViewportHeight()
        : this.getElementPhysicalHeight(this.scroller);
    },
  
    /**
     * Gets the height of the document
     * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
     * @return {int} the height of the document in pixels
     */
    getDocumentHeight : function () {
      var body = document.body,
        documentElement = document.documentElement;
  
      return Math.max(
        body.scrollHeight, documentElement.scrollHeight,
        body.offsetHeight, documentElement.offsetHeight,
        body.clientHeight, documentElement.clientHeight
      );
    },
  
    /**
     * Gets the height of the DOM element
     * @param  {Object}  elm the element to calculate the height of which
     * @return {int}     the height of the element in pixels
     */
    getElementHeight : function (elm) {
      return Math.max(
        elm.scrollHeight,
        elm.offsetHeight,
        elm.clientHeight
      );
    },
  
    /**
     * Gets the height of the scroller element
     * @return {int} the height of the scroller element in pixels
     */
    getScrollerHeight : function () {
      return (this.scroller === window || this.scroller === document.body)
        ? this.getDocumentHeight()
        : this.getElementHeight(this.scroller);
    },
  
    /**
     * determines if the scroll position is outside of document boundaries
     * @param  {int}  currentScrollY the current y scroll position
     * @return {bool} true if out of bounds, false otherwise
     */
    isOutOfBounds : function (currentScrollY) {
      var pastTop  = currentScrollY < 0,
        pastBottom = currentScrollY + this.getScrollerPhysicalHeight() > this.getScrollerHeight();
  
      return pastTop || pastBottom;
    },
  
    /**
     * determines if the tolerance has been exceeded
     * @param  {int} currentScrollY the current scroll y position
     * @return {bool} true if tolerance exceeded, false otherwise
     */
    toleranceExceeded : function (currentScrollY, direction) {
      return Math.abs(currentScrollY-this.lastKnownScrollY) >= this.tolerance[direction];
    },
  
    /**
     * determine if it is appropriate to unpin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should unpin, false otherwise
     */
    shouldUnpin : function (currentScrollY, toleranceExceeded) {
      var scrollingDown = currentScrollY > this.lastKnownScrollY,
        pastOffset = currentScrollY >= this.offset;
  
      return scrollingDown && pastOffset && toleranceExceeded;
    },
  
    /**
     * determine if it is appropriate to pin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should pin, false otherwise
     */
    shouldPin : function (currentScrollY, toleranceExceeded) {
      var scrollingUp  = currentScrollY < this.lastKnownScrollY,
        pastOffset = currentScrollY <= this.offset;
  
      return (scrollingUp && toleranceExceeded) || pastOffset;
    },
  
    /**
     * Handles updating the state of the widget
     */
    update : function() {
      var currentScrollY  = this.getScrollY(),
        scrollDirection = currentScrollY > this.lastKnownScrollY ? 'down' : 'up',
        toleranceExceeded = this.toleranceExceeded(currentScrollY, scrollDirection);
  
      if(this.isOutOfBounds(currentScrollY)) { // Ignore bouncy scrolling in OSX
        return;
      }
  
      if (currentScrollY <= this.offset ) {
        this.top();
      } else {
        this.notTop();
      }
  
      if(currentScrollY + this.getViewportHeight() >= this.getScrollerHeight()) {
        this.bottom();
      }
      else {
        this.notBottom();
      }
  
      if(this.shouldUnpin(currentScrollY, toleranceExceeded)) {
        this.unpin();
      }
      else if(this.shouldPin(currentScrollY, toleranceExceeded)) {
        this.pin();
      }
  
      this.lastKnownScrollY = currentScrollY;
    }
  };
  /**
   * Default options
   * @type {Object}
   */
  Headroom.options = {
    tolerance : {
      up : 0,
      down : 0
    },
    offset : 0,
    scroller: window,
    classes : {
      pinned : 'headroom--pinned',
      unpinned : 'headroom--unpinned',
      top : 'headroom--top',
      notTop : 'headroom--not-top',
      bottom : 'headroom--bottom',
      notBottom : 'headroom--not-bottom',
      initial : 'headroom'
    }
  };
  Headroom.cutsTheMustard = typeof features !== 'undefined' && features.rAF && features.bind && features.classList;

  return Headroom;
}));
},{}],2:[function(require,module,exports){
'use strict';

require('./diversity/directives');
require('./diversity/components');
require('./diversity/apps');

},{"./diversity/apps":4,"./diversity/components":9,"./diversity/directives":16}],3:[function(require,module,exports){
'use strict';

var diversityStore = new Vuex.Store({
  state: {
    showVideo: undefined,
    slidesPaused: undefined
  },
  mutations: {
    closeVideo: function closeVideo(state) {
      state.showVideo = undefined;
      // state.slidesPaused = undefined;
    },
    loadVideo: function loadVideo(state, videoId) {
      state.showVideo = videoId;
      state.slidesPaused = true;
    },
    pauseSlides: function pauseSlides(state) {
      state.slidesPaused = true;
    },
    playSlides: function playSlides(state) {
      state.slidesPaused = undefined;
    }
  }
});

module.exports = document.getElementById('homeDiversityApp') ? new Vue({
  el: '#homeDiversityApp',
  data: {
    hero: window.json.hero,
    quotes: window.json.quotes,
    statsSection: window.json.statsSection,
    affinityGroups: window.json.affinityGroups,
    globalDiversity: window.json.globalDiversity,
    connect: window.json.connect,
    forwardThinking: window.json.forwardThinking,
    activeGroup: undefined,
    shouldShowQuote: false,
    shouldShowSource: false,
    shouldSlideGreenBars: false,
    shouldSlideStatLine: false,
    shouldShowStatTagline: false,
    shouldShowBottomQuote: false,
    shouldShowBottomSource: false,
    shouldSlideOrangeBars: false,
    percentComplete: 0,
    player: undefined,
    slidesPaused: false
  },
  created: loadAPI(),
  computed: {
    stats: function stats() {
      return this.statsSection.stats.map(function (stat) {
        return {
          min: 0,
          max: stat.number,
          tagline: stat.tagline
        };
      });
    },
    showVideo: function showVideo() {
      this.slidesPaused = this.$store.state.slidesPaused;
      return this.$store.state.showVideo;
    }
  },
  watch: {
    showVideo: function showVideo() {
      if (this.showVideo !== undefined) {
        this.startVideo(this.showVideo);
      }
    }
  },
  methods: {
    getNumber: function getNumber(stat) {
      return parseInt(stat.max * this.percentComplete);
      // return parseInt(stat.min + ((stat.max - stat.min) * this.percentComplete))
    },
    openModal: function openModal(group) {
      this.activeGroup = group;
    },
    closeModal: function closeModal() {
      this.activeGroup = undefined;
    },
    shouldShowModal: function shouldShowModal() {
      return this.activeGroup != undefined;
    },
    showQuote: function showQuote(message) {
      if (this.shouldShowQuote === false && message.inView) {
        this.shouldShowQuote = true;
      }
    },
    initQuote: function initQuote(message) {
      var self = this;
      setTimeout(function () {
        self.showQuote(message);
      }, 800);
    },
    showSource: function showSource(message) {
      if (this.shouldShowSource === false && message.inView) {
        this.shouldShowSource = true;
      }
    },
    initSource: function initSource(message) {
      var self = this;
      setTimeout(function () {
        self.showSource(message);
      }, 1000);
    },
    slideGreenBars: function slideGreenBars(message) {
      if (this.shouldSlideGreenBars === false && message.inView) {
        this.shouldSlideGreenBars = true;
      }
    },
    slideStatLine: function slideStatLine(message) {
      if (this.shouldSlideStatLine === false && message.inView) {
        this.shouldSlideStatLine = true;
      }
    },
    showStatTagline: function showStatTagline(message) {
      if (this.shouldShowStatTagline === false && message.inView) {
        this.shouldShowStatTagline = true;
      }
    },
    initStatTagline: function initStatTagline(message) {
      var self = this;
      setTimeout(function () {
        self.showStatTagline(message);
      }, 1500);
    },
    showBottomQuote: function showBottomQuote(message) {
      if (this.shouldShowBottomQuote === false && message.inView) {
        this.shouldShowBottomQuote = true;
      }
    },
    initBottomQuote: function initBottomQuote(message) {
      var self = this;
      setTimeout(function () {
        self.showBottomQuote(message);
      }, 800);
    },
    showBottomSource: function showBottomSource(message) {
      if (this.shouldShowBottomSource === false && message.inView) {
        this.shouldShowBottomSource = true;
      }
    },
    initBottomSource: function initBottomSource(message) {
      var self = this;
      setTimeout(function () {
        self.showBottomSource(message);
      }, 1000);
    },
    slideOrangeBars: function slideOrangeBars(message) {
      if (this.shouldSlideOrangeBars === false && message.inView) {
        this.shouldSlideOrangeBars = true;
      }
    },
    countNumbers: function countNumbers(message) {
      var duration = 1500;
      var self = this;

      var addPercent = function addPercent() {
        if (self.percentComplete >= 1) {
          self.percentComplete = 1;
          clearInterval(this);
        } else {
          self.percentComplete += 0.01;
        }
      };

      if (this.percentComplete === 0 && message.inView) {
        setInterval(addPercent, duration / 100);
      }
    },
    pauseAndCloseVideoPlayer: function pauseAndCloseVideoPlayer() {
      this.$store.commit('closeVideo');
      if (this.player) this.player.pauseVideo();else console.log("No video available");
    },
    startVideo: function startVideo(videoId) {
      if (this.player) {
        if (this.player.getVideoData().video_id !== videoId) this.player.loadVideoById(videoId);
        this.player.playVideo();
      } else {
        this.player = new YT.Player('video-iframe', {
          videoId: videoId,
          host: 'https://www.youtube.com',
          frameborder: 0,
          height: '390',
          width: '640',
          playerVars: { autoplay: 1, showinfo: 0 },
          events: {
            'onReady': function onReady() {},
            'onStateChange': function onStateChange() {}
          }
        });
      }
    }
  },
  store: diversityStore
}) : undefined;

function loadAPI() {
  var firstScriptTag;
  var tag = document.createElement('script');

  tag.src = 'https://www.youtube.com/iframe_api';
  firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

},{}],4:[function(require,module,exports){
'use strict';

require('./home');
require('./variables');
require('./read-more');

},{"./home":3,"./read-more":5,"./variables":6}],5:[function(require,module,exports){
'use strict';

var readMore = {

    init: function init() {
        this.$ReadMore = $('.js-read-more');
        if (this.$ReadMore) {
            this.$trigger = this.$ReadMore.find('.js-toggle-btn');
            this.$contentCollapsed = this.$ReadMore.find('.js-full-copy');
            this.labelCollapsed = this.$contentCollapsed.data('label-more');
            this.labelExpanded = this.$contentCollapsed.data('label-less');
            this.visibility = false;
            this.activeClass = 'is-expanded';
            this.animationSpeed = 350;
            this.scrollUpOnCollapse = false;

            this.bindEvents();
        }
    },
    bindEvents: function bindEvents() {

        var _self = this;

        this.scrollUpOnCollapse = this.$ReadMore.data('scroll-on-collapse');

        _self.$trigger.on('click', function (ev) {
            ev.preventDefault();

            _self.toggleVisibility();
        });
    },
    toggleVisibility: function toggleVisibility() {
        this.visibility === true ? this.collapseContent() : this.expandContent();
    },
    expandContent: function expandContent() {
        this.visibility = true;

        this.$contentCollapsed.slideDown(this.animationSpeed, function () {
            if (window.stickyShare !== undefined) {
                window.stickyShare.update();
            }
        }).attr('aria-expanded', true).attr('aria-hidden', false).attr('tabindex', -1).focus();

        this.$trigger.addClass(this.activeClass).attr('aria-expanded', true).find('.btn-ghost-label').text(this.labelExpanded);
    },
    collapseContent: function collapseContent() {

        var _self = this;

        this.visibility = false;

        this.$contentCollapsed.slideUp(this.animationSpeed, function () {
            if (window.stickyShare !== undefined) {
                window.stickyShare.update();
            }
        }).attr('aria-expanded', false).attr('aria-hidden', true).attr('tabindex', -1);

        this.$trigger.removeClass(this.activeClass).attr('aria-expanded', false).find('.btn-ghost-label').text(_self.labelCollapsed);

        if (this.scrollUpOnCollapse) {
            $('body,html').animate({ scrollTop: this.$ReadMore.offset().top }, this.animationSpeed);
        }
    }
};

readMore.init();

module.exports = readMore;

},{}],6:[function(require,module,exports){
'use strict';

var globalVars = {

    device: {
        isIpad: null,
        isIphone: null
    },

    elementStates: {
        headerHeight: null
    },

    elements: {
        $siteHeader: $('.js-site-header')
    },

    isMobile: false,
    isMobileLandscape: false,
    isTabletMax: false
};

var setupValues,

//responsive media query function
mqMobile;

globalVars.elementStates = {
    headerHeight: globalVars.elements.$siteHeader.outerHeight()
};

//setup globalMagicController
globalVars.magicController = new ScrollMagic.Controller();

globalVars.sceneCollection = {};

setupValues = function setupValues(tableLanscape) {

    globalVars.tableLanscape = tableLanscape;
    globalVars.isTabletMax = window.innerWidth < 901 ? true : false;
    globalVars.isMobile = window.innerWidth < 767 ? true : false;
    globalVars.isMobileLandscape = window.innerWidth < 630 ? true : false;

    globalVars.elementStates.headerHeight = Math.ceil(globalVars.elements.$siteHeader.outerHeight());
};

//make sure this matches css
mqMobile = window.matchMedia('(max-width: 1024px)');

mqMobile.matches ? setupValues(true) : setupValues(false);

mqMobile.addListener(function (changed) {
    changed.matches ? setupValues(true) : setupValues(false);
});

navigator.userAgent.match(/iPhone/i) ? globalVars.device.isIphone = true : globalVars.device.isIphone = false;
navigator.userAgent.match(/iPod/i) ? globalVars.device.isIpad = true : globalVars.device.isIpad = false;

globalVars.windowResize = function () {

    var callbacks = [],
        running = false;

    // fired on resize event
    function resize() {

        if (!running) {
            running = true;

            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(runCallbacks);
            } else {
                setTimeout(runCallbacks, 66);
            }
        }
    }

    // run the actual callbacks
    function runCallbacks() {

        callbacks.forEach(function (callback) {
            callback();
        });

        running = false;
    }

    // adds callback to loop
    function addCallback(callback) {

        if (callback) {
            callbacks.push(callback);
        }
    }

    return {
        // public method to add additional callback
        add: function add(callback) {
            if (!callbacks.length) {
                window.addEventListener('resize', resize);
            }
            addCallback(callback);
        }
    };
}();

module.exports = globalVars;

},{}],7:[function(require,module,exports){
'use strict';

Vue.component('diversity-carousel', {
  props: ["interval"],
  data: function data() {
    return {
      carousel: window.json.carousel,
      activeSlide: 0,
      slideMove: 'forward'
    };
  },
  mounted: function mounted() {
    var self = this;
    if (this.interval >= 500) {
      setInterval(function () {
        Vue.nextTick(function () {
          self.nextSlide(true);
        });
      }, this.interval);
    }
  },
  computed: {
    slideLength: function slideLength() {
      return this.carousel.slides.length;
    },
    isPaused: function isPaused() {
      return this.$store.state.slidesPaused;
    }
  },
  methods: {
    activeClass: function activeClass(index) {
      return this.activeSlide ? true : false;
    },
    switchSlides: function switchSlides(slideBackward) {
      slideBackward = slideBackward ? slideBackward : false;
      this.$store.commit('pauseSlides');
      if (slideBackward) {
        this.previousSlide();
      } else {
        this.nextSlide();
      }
    },
    nextSlide: function nextSlide(isInterval) {
      if (!this.isPaused || !isInterval) {
        this.slideMove = 'forward';
        this.activeSlide + 1 == this.slideLength ? this.activeSlide = 0 : this.activeSlide++;
      }
    },
    previousSlide: function previousSlide() {
      this.slideMove = 'backward';

      this.activeSlide == 0 ? this.activeSlide = this.slideLength - 1 : this.activeSlide--;
    },
    playVideo: function playVideo(videoId) {
      this.$store.commit('loadVideo', videoId);
    },
    afterLeave: function afterLeave(el) {
      //force class removal
      el.classList.remove('slide-leave-to');
    },
    pauseVideo: function pauseVideo() {
      if (this.isPaused) {
        this.$store.commit('playSlides');
      } else {
        this.$store.commit('pauseSlides');
      }
    },
    skipToSlide: function skipToSlide(index) {
      this.$store.commit('pauseSlides');
      this.activeSlide = index;
    }
  }
});

},{}],8:[function(require,module,exports){
'use strict';

Vue.component('globalCarousel', {
  props: ["interval"],
  data: function data() {
    return {
      globalDiversity: window.json.globalDiversity,
      activeSlide: 0,
      slideMove: 'forward'
    };
  },
  mounted: function mounted() {
    var self = this;
    if (this.interval >= 500) {
      setInterval(function () {
        self.nextSlide();
      }, this.interval);
    }
  },
  computed: {
    slideLength: function slideLength() {
      return this.globalDiversity.slides.length;
    }
  },
  methods: {
    activeClass: function activeClass(index) {
      return this.activeSlide ? true : false;
    },
    nextSlide: function nextSlide() {
      this.slideMove = 'forward';

      this.activeSlide + 1 == this.slideLength ? this.activeSlide = 0 : this.activeSlide++;
    },
    previousSlide: function previousSlide() {
      this.slideMove = 'backward';

      this.activeSlide == 0 ? this.activeSlide = this.slideLength - 1 : this.activeSlide--;
    }
  }
});

},{}],9:[function(require,module,exports){
'use strict';

require('./diversity-carousel');
require('./global-carousel');
require('./site-header');
require('./variables');
require('./setup-fixed-header');
require('./toggle-menu');
require('./navigation');
require('./language-menu');

},{"./diversity-carousel":7,"./global-carousel":8,"./language-menu":10,"./navigation":11,"./setup-fixed-header":12,"./site-header":13,"./toggle-menu":14,"./variables":15}],10:[function(require,module,exports){
'use strict';

var language_menu = {

    init: function init() {
        this.menu = document.querySelector('.js-language-menu');
        this.menu_button = document.querySelector('.js-language-menu__button');
        this.menu_links = document.querySelectorAll('.language-menu__link');
        this.menu_options = document.querySelector('.language-menu__options');

        if (!this.menu || !this.menu_button) {
            return;
        }

        this.menu_button.addEventListener('click', function (e) {
            e.preventDefault();

            if (language_menu.menu_options.getAttribute('aria-hidden') === 'true') {
                language_menu.open_menu();
            } else {
                language_menu.close_menu();
            }
        });
    },

    open_menu: function open_menu() {
        this.menu.classList.add('is-open');
        this.menu_options.setAttribute('aria-hidden', false);
        this.menu_button.setAttribute('aria-expanded', true);
        this.set_focus('0');
    },

    close_menu: function close_menu() {
        this.menu.classList.remove('is-open');
        this.menu_options.setAttribute('aria-hidden', true);
        this.menu_button.setAttribute('aria-expanded', false);
        this.set_focus('-1');
    },

    set_focus: function set_focus(state) {

        for (var i = 0; i < this.menu_links.length; i++) {
            var link = this.menu_links[i];
            var tabindex = link.setAttribute('tabindex', state);
        }
    }
};

language_menu.init();

module.exports = language_menu;

},{}],11:[function(require,module,exports){
'use strict';

var navigation = {

    init: function init() {
        this.siteheader = document.querySelector('.siteheader');
        this.nav_container = document.querySelector('.nav');
        this.search_container = document.querySelector('.globalsearch');
        this.nav_secondary = document.querySelector('#nav-secondary');

        if (!this.nav_container) {
            return;
        }

        this.toggle_nav.init();
        this.toggle_subnav.init();
        this.toggle_search.init();

        //esc key event
        document.addEventListener('keyup', function (e) {
            if (e.which === 27) {
                navigation.toggle_nav.close_nav();
                navigation.toggle_subnav.close_active_subnavs();
                navigation.toggle_search.close_search();
            }
        });
    },

    close_all: function close_all() {
        navigation.toggle_nav.close_nav();
        navigation.toggle_subnav.close_active_subnavs();
        navigation.toggle_search.close_search();
    },

    pause_hero_carousel: function pause_hero_carousel(state) {

        if (window.hero_flkty) {
            if (state) {
                window.hero_flkty.pausePlayer();
            } else {
                window.hero_flkty.unpausePlayer();
            }
        }
    },

    get_cookie_object: function get_cookie_object() {
        if (!this.cookie) {
            this.cookie = document.querySelector('#usercentrics-button');
        }
    },

    toggle_search: {

        init: function init() {

            this.search_toggle_button = document.querySelector('.js-search-toggle');
            this.search_form = document.querySelector('.js-globalsearch__form');
            this.search_input = document.querySelector('#global-search-box');

            if (!navigation.search_container) {
                return;
            }

            this.search_toggle_button.addEventListener('click', function (e) {
                e.preventDefault();

                if (navigation.search_container.classList.contains('is-open')) {
                    navigation.toggle_search.close_search();
                } else {
                    navigation.toggle_search.open_search();
                    navigation.toggle_search.search_toggle_button.blur();
                }
            });
        },

        open_search: function open_search() {

            this.search_toggle_button.classList.add('is-active');
            navigation.search_container.classList.add('is-open');

            // set focus
            this.search_input.focus();

            // set aria
            this.search_form.setAttribute('aria-hidden', 'false');
            this.search_toggle_button.setAttribute('aria-expanded', 'true');

            // close subnav and secondary navs
            navigation.toggle_subnav.close_active_subnavs();
            navigation.toggle_nav.close_nav();

            // pause carousel
            navigation.pause_hero_carousel(true);
        },

        close_search: function close_search() {

            this.search_toggle_button.classList.remove('is-active');
            this.search_toggle_button.blur();

            // set aria
            this.search_form.setAttribute('aria-hidden', 'true');
            this.search_toggle_button.setAttribute('aria-expanded', 'false');

            if (navigation.search_container) {
                navigation.search_container.classList.remove('is-open');
            }

            // un pause carousel
            navigation.pause_hero_carousel(false);
        }
    },

    toggle_nav: {

        init: function init() {

            this.nav_toggle_button = document.querySelector('.js-nav-toggle');

            if (!this.nav_toggle_button) {
                return;
            }

            this.nav_toggle_button.addEventListener('click', function (e) {
                e.preventDefault();

                if (navigation.nav_container.classList.contains('is-open')) {
                    navigation.toggle_nav.close_nav();
                } else {
                    navigation.toggle_nav.open_nav();
                }
            });
        },

        open_nav: function open_nav() {

            this.nav_toggle_button.classList.add('is-active');
            // navigation.nav_container.classList.add('nav--has-transition');
            navigation.nav_container.classList.add('is-open');

            // set focus
            if (window.matchMedia && window.matchMedia('(min-width: 1200px)').matches) {
                navigation.nav_secondary.setAttribute('tabindex', '-1');
                navigation.nav_secondary.focus();
            } else if (window.matchMedia && window.matchMedia('(max-width: 1000px)').matches) {
                navigation.get_cookie_object();
                navigation.cookie.classList.add('hide-cookie');
            }

            // close subnavs
            navigation.toggle_subnav.close_active_subnavs();

            // close search
            navigation.toggle_search.close_search();

            // pause carousel
            navigation.pause_hero_carousel(true);
        },

        close_nav: function close_nav() {

            if (!this.nav_toggle_button) {
                return;
            }

            this.nav_toggle_button.classList.remove('is-active');
            // navigation.nav_container.classList.remove('nav--has-transition');
            navigation.nav_container.classList.remove('is-open');
            navigation.nav_secondary.removeAttribute('tabindex');

            if (window.matchMedia && window.matchMedia('(max-width: 1000px)').matches) {
                navigation.get_cookie_object();
                navigation.cookie.classList.remove('hide-cookie');
            }

            // un pause carousel
            navigation.pause_hero_carousel(false);
        }
    },

    toggle_subnav: {

        init: function init() {
            this.sub_nav_links = document.querySelectorAll('.js-nav-has-subnav');

            //sub nav link event
            for (var i = 0; i < this.sub_nav_links.length; i++) {
                var sub_nav_link = this.sub_nav_links[i];
                navigation.toggle_subnav.bind_links(sub_nav_link);
            }
        },

        bind_links: function bind_links(sub_nav_link) {

            var event_binding = function event_binding(target) {
                // this.close_active_subnavs(target);
                // this.open_subnav(target);

                if (target.classList.contains('is-active')) {
                    navigation.toggle_subnav.close_subnav(target);
                } else {
                    navigation.toggle_subnav.open_subnav(target);
                }
            };

            sub_nav_link.addEventListener('click', function (e) {
                var target = e.currentTarget;

                if (window.matchMedia && window.matchMedia('(min-width: 1200px)').matches) {
                    e.preventDefault();
                    event_binding(target);
                }
            });

            sub_nav_link.addEventListener('keydown', function (e) {
                var target = e.currentTarget;

                if (e.which !== 32) {
                    return;
                }

                if (window.matchMedia && window.matchMedia('(min-width: 1200px)').matches) {
                    e.preventDefault();
                    event_binding(target);
                }
            });
        },

        open_subnav: function open_subnav(target) {
            var target_subnav = target.nextElementSibling;

            // close secondary nav
            navigation.toggle_nav.close_nav();

            // close search
            navigation.toggle_search.close_search();

            // close open subnavs
            navigation.toggle_subnav.close_active_subnavs(target);

            // open subnav
            target.classList.add('is-active');
            target_subnav.classList.add('is-open');

            // pause carousel
            navigation.pause_hero_carousel(true);
        },

        close_subnav: function close_subnav(target) {
            var target_subnav = target.nextElementSibling;

            // close subnav
            target.blur();
            target.classList.remove('is-active');
            target_subnav.classList.remove('is-open');

            // unpause carousel
            navigation.pause_hero_carousel(false);
        },

        close_active_subnavs: function close_active_subnavs(target) {
            // close open subnavs
            for (var i = 0; i < this.sub_nav_links.length; i++) {

                var link = this.sub_nav_links[i];

                if (target !== link) {
                    var subnav = link.nextElementSibling;
                    link.classList.remove('is-active');
                    subnav.classList.remove('is-open');
                    link.blur();
                }
            }
        }
    }
};

navigation.init();

module.exports = navigation;

},{}],12:[function(require,module,exports){
'use strict';

module.exports = function () {

    var $siteHeader, animateHeaderOffset, pageOffset, fixedHeaderClass, rAFTicker;

    //pull in global vars

    fixedHeaderClass = 'setup-fixed-header';

    /*=============================================
    =            REquestion animation Frame            =
    =============================================*/
    function setupWindowOffsets() {
        animateHeaderOffset = 500;
    }

    function attachScrollEvent() {
        // only listen for scroll events
        window.addEventListener('scroll', requestTicker, false);
    }

    function removeScrollEvent() {
        //remove ScrollEvent
        window.removeEventListener('scroll', requestTicker, false);
    }

    function requestTicker() {
        if (!rAFTicker) {
            requestAnimationFrame(windowScrollLogic);
            rAFTicker = true;
        }
    }

    function windowScrollLogic() {
        pageOffset = window.pageYOffset;

        if (pageOffset >= animateHeaderOffset) {
            $siteHeader.addClass(fixedHeaderClass);
        } else {
            $siteHeader.removeClass(fixedHeaderClass);
        }

        rAFTicker = false;
    }

    return {
        //method to initialize script
        init: function init($headerEl) {
            $siteHeader = $headerEl;

            setupWindowOffsets();
            attachScrollEvent();
        }
    };
}();

},{}],13:[function(require,module,exports){
'use strict';

window.Headroom = require('headroom.js');

var header = {

    init: function init() {
        this.siteheader = document.querySelector('.siteheader');
        this.navigation = document.querySelector('#site-navigation');
        this.search = document.querySelector('.globalsearch');

        if (!this.siteheader) {
            return;
        }

        var headroom = new Headroom(this.siteheader, {
            offset: 300,
            classes: {
                initial: 'siteheader--headroom',
                pinned: 'siteheader--pinned',
                unpinned: 'siteheader--unpinned',
                top: 'siteheader--top',
                notTop: 'siteheader--not-top',
                bottom: 'siteheader--bottom',
                notBottom: 'siteheader--not-bottom'
            },
            onUnpin: function onUnpin() {
                //close all nav items

                if (header.is_nav_open()) {
                    //don't unpin if nav/subnav or search is open
                    this.elem.classList.remove(this.classes.unpinned);
                    this.elem.classList.add(this.classes.pinned);
                } else {
                    this.elem.classList.add(this.classes.unpinned);
                    this.elem.classList.remove(this.classes.pinned);
                }
            },
            tolerance: {
                up: 5,
                down: 0
            }
        });
        headroom.init();
    },
    is_nav_open: function is_nav_open() {

        var subnav_open = document.querySelector('.nav__sub.is-open');

        // test nav
        if (this.navigation.classList.contains('is-open')) {
            return true;
        } else if (this.search.classList.contains('is-open')) {
            return true;
        } else if (subnav_open) {
            return true;
        } else {
            return false;
        }
    }
};

var $siteSearchInput = $('#global-search-box');
var $siteSearchButton = $('#global-search-button');

$siteSearchButton.on('click', function () {
    var query = $siteSearchInput.val();
    var landingPage = $siteSearchInput.attr('data-landing');
    window.location.href = landingPage + '?query=' + encodeURIComponent(query);
    return false;
});

$siteSearchInput.on('keyup', function (e) {
    if (e.keyCode == 13) {
        var query = $siteSearchInput.val();
        var landingPage = $siteSearchInput.attr('data-landing');
        window.location.href = landingPage + '?query=' + encodeURIComponent(query);
        return false;
    }
});

var $peopleSearchInput = $('#people-search-input');
var $peopleSearchButton = $('#people-search-button');

$peopleSearchButton.on('click', function () {
    var query = $peopleSearchInput.val();
    var peopleLanding = $peopleSearchInput.attr('data-landing');
    window.location.href = peopleLanding + '?keyword=' + encodeURIComponent(query);
    return false;
});

$peopleSearchInput.on('keyup', function (e) {
    if (e.keyCode == 13) {
        var query = $peopleSearchInput.val();
        var peopleLanding = $peopleSearchInput.attr('data-landing');
        window.location.href = peopleLanding + '?keyword=' + encodeURIComponent(query);
        return false;
    }
});

var $capabilitiesSearchInput = $('#capabilities-search-input');
var $capabilitiesSearchButton = $('#capabilities-search-button');

$capabilitiesSearchButton.on('click', function () {
    var query = $capabilitiesSearchInput.val();
    var capabilitiesLanding = $capabilitiesSearchInput.attr('data-landing');
    window.location.href = capabilitiesLanding + '?page=1&scroll=550&keyword=' + encodeURIComponent(query);
    return false;
});

$capabilitiesSearchInput.on('keyup', function (e) {
    if (e.keyCode == 13) {
        var query = $capabilitiesSearchInput.val();
        var capabilitiesLanding = $capabilitiesSearchInput.attr('data-landing');
        window.location.href = capabilitiesLanding + '?page=1&scroll=550&keyword=' + encodeURIComponent(query);
        return false;
    }
});

header.init();

module.exports = header;

},{"headroom.js":1}],14:[function(require,module,exports){
'use strict';

function ToggleMenu(toggleEl, classOptions) {

    this.$toggleMenu = toggleEl;
    this.$expandableMenu = this.$toggleMenu.find('.' + classOptions.expandableMenu);

    this.classNames = classOptions || {
        triggerClass: 'js-trigger',
        expandableMenu: 'js-menu',
        showOptions: 'show-menu',
        navOptionsClass: 'js-option',
        selectedOptionClass: 'is-selected',
        navOptions: 'js-nav',
        updateToggleLabel: false
    };

    this.bindEvents();
}

ToggleMenu.prototype.updateMobileLabel = function mobileLabel($navNode) {
    this.$toggleMenu.find('.' + this.classNames.triggerClass).text($navNode.text());
};

ToggleMenu.prototype.updateNavState = function updateClasses($navOption) {

    this.$toggleMenu.find('.' + this.classNames.selectedOptionClass).removeClass(this.classNames.selectedOptionClass);

    $navOption.parent().addClass(this.classNames.selectedOptionClass);

    if (this.classNames.updateToggleLabel) {

        this.updateMobileLabel($navOption);
    }
};

ToggleMenu.prototype.toggleMenu = function toggleMenu() {
    var _self = this;

    if (_self.$toggleMenu.data('is-expanded')) {

        _self.$toggleMenu.removeClass(_self.classNames.showOptions);

        _self.$toggleMenu.attr('aria-expanded', false).data('is-expanded', false);

        var $trigger = $('.' + _self.classNames.triggerClass);
        $trigger.attr('aria-expanded', false);

        var $expandableMenu = $('.' + _self.classNames.expandableMenu);
        $expandableMenu.attr('aria-hidden', true);

        var $navOptions = $('.' + _self.classNames.navOptions);
        $navOptions.attr('tabindex', -1);
    } else {
        _self.$toggleMenu.addClass(_self.classNames.showOptions);

        _self.$toggleMenu.attr('aria-expanded', true).data('is-expanded', true);

        var $trigger = $('.' + _self.classNames.triggerClass);
        $trigger.attr('aria-expanded', true);

        var $expandableMenu = $('.' + _self.classNames.expandableMenu);
        $expandableMenu.attr('aria-hidden', false);

        var $navOptions = $('.' + _self.classNames.navOptions);
        $navOptions.attr('tabindex', 1);
    }
};

ToggleMenu.prototype.bindEvents = function bind() {
    var _self = this;

    //set data attribute to keep track of if toggle is expanded or not
    if (typeof _self.$toggleMenu.data('is-expanded') === 'undefined') {

        _self.$toggleMenu.data('is-expanded', false);
    }

    if (_self.$toggleMenu.data('is-expanded')) {

        //set active class if expanded by default
        _self.$toggleMenu.addClass(_self.classNames.showOptions);
    }

    //Initialize event listeners to the toggle button and navigation items
    _self.$toggleMenu.on('click.toggleMenu', '.' + _self.classNames.triggerClass, function (ev) {
        ev.stopPropagation();

        _self.toggleMenu();
    });

    if (_self.classNames.navOptionsClass) {
        _self.$toggleMenu.on('click.toggleMenuButtons', '.' + _self.classNames.navOptionsClass, function (ev) {
            ev.stopPropagation();

            _self.toggleMenu();
            _self.updateNavState($(this));
        });
    }
};

module.exports = ToggleMenu;

},{}],15:[function(require,module,exports){
arguments[4][6][0].apply(exports,arguments)
},{"dup":6}],16:[function(require,module,exports){
'use strict';

require('./scrollwatch');

},{"./scrollwatch":17}],17:[function(require,module,exports){
'use strict';

Vue.directive('scrollwatch', {
  data: {
    sections: [],
    states: {
      aboveScreen: 'aboveScreen',
      aboveMiddle: 'aboveMiddle',
      belowMiddle: 'belowMiddle',
      belowScreen: 'belowScreen'
    }
  },
  inserted: function inserted(element, _ref) {
    var name = _ref.name,
        value = _ref.value;

    var self = Vue.directive(name);

    if (self.data.sections.length === 0) {
      self.addScrollListeners();
    }

    self.data.sections.push({
      element: element,
      onStateChange: value,
      state: undefined
    });

    self.onScroll();
  },
  unbind: function unbind(element, _ref2) {
    var name = _ref2.name;

    var self = Vue.directive(name);

    self.removeFromSections(element);

    if (self.data.sections.length === 0) {
      self.removeScrollListeners();
    }
  },
  addScrollListeners: function addScrollListeners() {
    window.addEventListener('scroll', this.onScroll, this.supportsPassiveListening() ? { passive: true } : false);
  },
  removeScrollListeners: function removeScrollListeners() {
    window.removeEventListener('scroll', this.onScroll);
  },
  supportsPassiveListening: function supportsPassiveListening() {
    try {
      window.addEventListener('test', null, Object.defineProperty({}, 'passive', { get: function get() {
          return true;
        } }));
      return true;
    } catch (ignore) {
      return false;
    }
  },
  onScroll: function onScroll() {
    var self = Vue.directive('scrollwatch');

    self.data.sections.forEach(function (section) {
      var oldState = section.state;
      section.state = self.getStateOf(section.element);

      if (section.state !== oldState) {
        section.onStateChange({
          old: oldState,
          new: section.state,
          el: section.element,
          inView: self.inView(section.element)
        });
      }
    });
  },
  removeFromSections: function removeFromSections(element) {
    this.data.sections = this.data.sections.filter(this.notElement(element));
  },

  notElement: function notElement(element) {
    return function (section) {
      return section.element !== element;
    };
  },
  getStateOf: function getStateOf(element) {
    var elementY = this.getElementY(element);
    var windowTop = this.getWindowTop();
    var windowMiddle = this.getWindowMiddle();
    var windowBottom = this.getWindowBottom();
    var states = this.data.states;

    return elementY > windowBottom ? states.belowScreen : elementY > windowMiddle ? states.belowMiddle : elementY > windowTop ? states.aboveMiddle : states.aboveScreen;
  },
  getElementY: function getElementY(element) {
    return element.getBoundingClientRect().top + this.getWindowTop();
  },
  getWindowTop: function getWindowTop() {
    return window.pageYOffset;
  },
  getWindowMiddle: function getWindowMiddle() {
    return this.getWindowTop() + this.getWindowHeight() / 2;
  },
  getWindowBottom: function getWindowBottom() {
    return this.getWindowTop() + this.getWindowHeight();
  },
  getWindowHeight: function getWindowHeight() {
    return window.innerHeight;
  },
  inView: function inView(element) {
    var elementBounds = element.getBoundingClientRect();
    return elementBounds.bottom > 0 && elementBounds.top < this.getWindowHeight();
  }
});

},{}]},{},[2]);
